// MA-107: reactive "the outbox is holding writes" flag for the OfflineBanner.
// Mirrors useOutboxDrain's eligibility (real session + both ids): without them
// the drain never runs, so we must not claim "we'll keep trying".
import { useEffect, useState } from "react";
import { useRealSession } from "@/lib/persistence";
import {
  OUTBOX_POLL_MS,
  countHeldWrites,
  holdingEnabled,
  holdingLineVisible,
  nextHeldSince,
} from "./outboxPending";

export function useOutboxHolding(
  localChildId: string | null | undefined,
  canonicalStudentId: string | null | undefined,
): boolean {
  const persistEnabled = useRealSession();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!holdingEnabled(persistEnabled, localChildId, canonicalStudentId)) {
      setVisible(false);
      return;
    }
    let since: number | null = null;
    const tick = () => {
      const now = Date.now();
      since = nextHeldSince(since, countHeldWrites(localChildId, canonicalStudentId, now), now);
      setVisible(holdingLineVisible(since, now));
    };
    tick();
    const id = setInterval(tick, OUTBOX_POLL_MS);
    return () => clearInterval(id);
  }, [persistEnabled, localChildId, canonicalStudentId]);

  return visible;
}
